<div #overlay id="modalTalent" class="modal fade" [ngClass]="{ 'show' : visible }" role="dialog" style="display: block;"
    (click)="fastEventKilling($event)">
    <div id="{{dialogId || ''}}" class="modal-dialog" [ngStyle]="ngStyle"
        [ngClass]="{ 'modal-sm': size == dialogSize.Small, 'modal-lg': size == dialogSize.Large }" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div style="display:flex; flex-direction:row; flex-wrap:nowrap;">
                  @if (title) {
                    <h5 class="modal-title">{{title}}</h5>
                  }

                  @if (cancelText || showCloseButton) {
                    <button style="margin-top: -20px; margin-left:auto;" type="button" class="close"
                      data-bs-dismiss="modal" aria-label="Close" (click)="close($event)">
                      <span aria-hidden="true">×</span>
                    </button>
                  }
                </div>
            </div>
            <div class="modal-body">
                <ng-content></ng-content>
            </div>
            <div class="modal-footer">
              @if (cancelText) {
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close($event)">{{cancelText}}</button>
              }

              @if (okText) {
                <button type="button" class="btn btn-primary" (click)="accept($event)">{{okText}}</button>
              }
            </div>
        </div>
    </div>
</div>
